import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

interface ComingSoonProps {
  headline: string;
  lead: string;
}

export function ComingSoon({ headline, lead }: ComingSoonProps) {
  return (
    <div style={{ maxWidth: '480px', paddingTop: '2rem' }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        fontFamily: 'var(--font-mono)',
        fontSize: '0.68rem',
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: 'var(--copper-300)',
        marginBottom: '1.25rem',
      }}>
        <span style={{ width: '18px', height: '1px', background: 'var(--copper-500)', display: 'inline-block' }} />
        Funkcija v pripravi
      </div>

      <h1 style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 560,
        fontSize: '2.25rem',
        color: '#fff',
        lineHeight: 1.08,
        letterSpacing: '-0.022em',
        marginBottom: '1rem',
      }}>
        {headline}
      </h1>

      <p style={{
        fontSize: '1rem',
        color: 'var(--app-muted)',
        lineHeight: 1.62,
        marginBottom: '2.5rem',
      }}>
        {lead}
      </p>

      <Link
        to="/"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.4rem',
          fontFamily: 'var(--font-mono)',
          fontSize: '0.82rem',
          color: 'var(--app-muted)',
          textDecoration: 'none',
          transition: 'color var(--dur-fast)',
        }}
      >
        <ArrowLeft size={15} strokeWidth={1.6} />
        Nazaj na pregled
      </Link>
    </div>
  );
}
